import axios from 'axios';
import React from 'react';
import Properties from "../const/Properties";
import CustomModal from "../thema/tema1/component/CustomModal";
import Footer from "../thema/tema1/component/Footer";
import Header from "../thema/tema1/component/Header";
import PageContext from "../thema/tema1/component/PageContext";
import SideMenu from "../thema/tema1/component/SideMenu";
import { withRouter } from 'react-router-dom';

const active = { Home: "active" };

class UcretBelirlePopup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tasimaId: localStorage.getItem("tasimaId"),
            gemiUcreti: false,
            hepsiGemi: false,
            hepsiUcak: false,
            aciklama: "",
            gemiUcretiOdeme: 0,
            baf: false,
            ens: false,
            bafOdeme: 0,
            ets: false,
            etsOdeme: 0,
            liman: false,
            limanOdeme: 0,
            soforUcreti: 0,
            soforUcretiOdeme: 0,
            ekSofor: 0,
            ekSoforOdeme: 0,
            xray: false,
            xrayOdeme: 0,
            yanici: false,
            yaniciOdeme: 0,
            rezervasyon: false,
            rezervasyonOdeme: 0,
            forklift: 0,
            forkliftOdeme: 0,
            ceza: 0,
            cezaOdeme: 0,
            guncelBorc: 0,
            hizmetBedeli: 0,
            ardiye: 0,
            ardiyeOdeme: 0,
            doktorluk: 0,
            doktorlukOdeme: 0,
            yolGecisUcreti: 0,
            yolGecisUcretiOdeme: 0,
            yolGecisUcretiSecim: "",
            gidecegiUlke: 0,
            genel: 0,
            gidecegiUlkeOdeme: 0,
            sigorta: 0,
            sigortaOdeme: 0,
            sigortaSecim: "",
            sigorta1ay: 0,
            sigorta2ay: 0,
            sigorta3ay: 0,
            gurbulak: 0,
            esendere: 0,
            dilucu: 0,
            toplam: 0,
            content: [],
            pageCount: 0,
            totalRow: 0,
            startRow: 0,
            endRow: 0,
            silId: 0,
            duzenleId: 0,
            silModal: 'none',
            title: ["STATU", "TARİH", "ÇEKİCİ PLAKA", "İŞLEM ÜCRETİ", "İŞLEMLER"],
            showDuzenle: false,
            duzenle: false,
            error: 0
        };
        this.get();

    }


    componentDidMount() {
        this.gecislerDoldur();
    }
    gecislerDoldur = () => {
            let status = true;
            if (status) {
                axios({
                    method: 'get',
                    url: Properties.baseUrl + '/tarife/get',
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("token")
                    }
                })
                    .then(res => {
                        console.log(res.data);
                        this.setState({ sigorta1ay: res.data.sigorta1ay });
                        this.setState({ sigorta2ay: res.data.sigorta2ay });
                        this.setState({ sigorta3ay: res.data.sigorta3ay });
                        this.setState({ gurbulak: res.data.gurbulak });
                        this.setState({ esendere: res.data.esendere });
                        this.setState({ dilucu: res.data.dilucu });
                    }).catch(res => {
                    window.unsuccessful((this.state.showDuzenle ? "Tarife Güncellenemedi." : "Tarife Kaydedilemedi."));
                });
            }
    }
    makbuzYazdir = (e) => {
        const popupWin = window.open('', '_blank');
        popupWin.document.open();
        let gidecegiUlke = 0;
        let gidecegiUlkeStr = "";
        let tutar = 0;
        let yanici = 0;
        let tarih = 0;
        let plaka = "";
        let firma = "";
        let turStr = "";
        axios({
            method: 'get',
            url: Properties.baseUrl + '/tasima/get/'+this.state.tasimaId,
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        })
            .then(res => {
                console.log(res.data);
                firma = res.data.firmaAdi;
                tutar = res.data.gelir;
                yanici = res.data.yanici;
                tarih = res.data.tarih;
                plaka = res.data.cekiciPlaka + " / " + res.data.dorsePlaka;
                gidecegiUlke = res.data.gidecegiUlke;
                if(gidecegiUlke==1)
                {
                    gidecegiUlkeStr= "Trieste";
                }
                else if(gidecegiUlke==2)
                {
                    gidecegiUlkeStr= "Bari";
                }
                else if(gidecegiUlke==3)
                {
                    gidecegiUlkeStr= "Sete";
                }
                if(this.props.tur == 1 || this.props.tur == 4)
                {
                    turStr = "İHRACAT";
                }
                else
                {
                    turStr = "İTHALAT";
                }
                popupWin.document.write(`
    <html>
<!-- Google Font: Source Sans Pro -->
<style>
body{
font-size: 12px;
}
    .logo{
        margin-top: 40px;
        position: absolute;
        width: 150px;
        margin-left: -50px;
    }

    .years20{
        margin-top: 30px;
        position: absolute;
        margin-left: 550px;
    }
    .title{
        margin-top: 97px;
        position: absolute;
        margin-left: 357px;
    }
    .years20 img{
        width: 150px;
    }
    .firma{
    position: absolute;
        margin-top: 250px;
    }
    .plaka{
    position: absolute;
        margin-top: 274px;
    }
    .hat{
    position: absolute;
        margin-top: 346px;
    }
    .tur{
    position: absolute;
        margin-top: 346px;
        margin-left: 357px;
    }
    .toplam{
    position: absolute;
        margin-top: 250px;
        margin-left: 450px;
    }
    .tutar{
    position: absolute;
        margin-top: 274px;
        margin-left: 450px;
    }
    .yanici{
    position: absolute;
        margin-top: 298px;
        margin-left: 450px;
    }
    .aciklama{
    position: absolute;
        margin-top: 390px;
    }
    .enalt{
    position: absolute;
        margin-top: 424px;
    }
    .left
    {
        float: left;
    }
    .border
    {
        border: solid 1px #000;
        padding: 2px;
    }
    .width80{
        width: 80px;
    }
    .width50{
        width: 50px;
    }
    .width100{
        width: 100px;
    }
    .width140{
        width: 140px;
    }
    .width150{
        width: 150px;
    }
    .width200{
        width: 200px;
    }
    .width580{
        width: 580px;
            min-height: 15px;   
    }
    .width340{
        width: 340px;
        font-size: 10px;
    }
</style>
<head>
    <title>Print</title>
</head>
<body onload="window.print()" >
<div>
    <div class="header left">
        <div class="logo left">
            <img src="/thema/tema1/dist/img/makbuzlogo.png">
        </div>
        <div class="title left"> TAHSİLAT MAKBUZU</div>
        <div class="years20">
            <img src="/thema/tema1/dist/img/20years.png">
            <div style="margin-left: -60px;" ><div class="left tarih border width50">TARİH</div><div class="tarihsag left border width140">`+tarih+`</div></div>
        </div>
    </div>
    <div class="content left">
        <div>
            <div class="firma left"><div class="left tarih border width80">FİRMA</div><div class="tarihsag left border width200">`+firma+`</div></div>
            <div class="left plaka"> <div class="left tarih border width80">PLAKA</div><div class="tarihsag left border width200">`+plaka+` €</div></div>
            <div class="left toplam"> <div class="left tarih border width80">TOPLAM</div><div class="tarihsag left border width150">`+(tutar+yanici)+` €</div></div>
            <div class="left tutar"> <div class="left tarih border width80">TUTAR</div><div class="tarihsag left border width150">`+tutar+` €</div></div>
            <div class="left yanici `+(yanici!=0?"goster":"gosterme")+`"> <div class="left tarih border width80">YANİCİ</div><div class="tarihsag left border width150">`+yanici+` €</div></div>
            <div class="left hat"> <div class="left tarih border width80">Hat:</div><div class="tarihsag left border width150">`+gidecegiUlkeStr+`</div></div>
            <div class="left tur"> <div class="left tarih border width80">`+turStr+`</div><div class="tarihsag left border width150">X</div></div>
            <div class="left aciklama"> <div class="left tarih border width100">AÇIKLAMA</div><div class="tarihsag left border width580">`+this.state.aciklama+`</div></div>
            <div class="left enalt"> <div class="left tarih border width340">Aydıntepe Mah. 100.Yıl cad. No:12/33 P:Code: 34947 Tuzla/İstanbul</div><div class="tarihsag left border width340">ucarsoy@gmail.com | www.ucarsoy.com</div></div>
    </div>
        <div>
</div>
</div>
</div>
</body>

</html>
  
    `);
                popupWin.document.close();
            }).catch(res => {
        });

        /*window.history.back();*/
        /*window.disableModal();*/
        /*axios({
            method: 'post',
            url: Properties.baseUrl + '/tasima/changeDurum',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem("token")
            },
            data: {
                id: this.state.makbuzId,
                durum: this.state.makbuzDurum,
            }
        })
            .then(res => {
                window.successful((this.state.showDuzenle ? "Makbuz Güncellendi." : "Makbuz Kaydedildi"));
            }).catch(res => {
            window.unsuccessful((this.state.showDuzenle ? "Makbuz Güncellenemedi." : "Makbuz Kaydedilemedi."));
        });*/
    }

    ekOdemeMakbuzYazdir = (e) => {
        const popupWin = window.open('', '_blank');
        popupWin.document.open();
        let gidecegiUlke = 0;
        let gidecegiUlkeStr = "";
        let tutar = 0;
        let yanici = 0;
        let tarih = 0;
        let plaka = "";
        let firma = "";
        let turStr = "";
        let forklift = 0;
        let rezervasyon = 0;
        let ceza = 0;
        let yolGecisUcreti = 0;
        let sigorta = 0;
        let ardiye = 0;
        let guncelborc = 0;
        let doktorlukucreti = 0;
        axios({
            method: 'get',
            url: Properties.baseUrl + '/tasima/get/'+this.state.tasimaId,
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        })
            .then(res => {
                console.log(res.data);
                firma = res.data.firmaAdi;
                tutar = res.data.gelir;
                yanici = res.data.yanici;
                tarih = res.data.tarih;
                plaka = res.data.cekiciPlaka + " / " + res.data.dorsePlaka;
                gidecegiUlke = res.data.gidecegiUlke;
                forklift = res.data.forklift;
                rezervasyon = res.data.rezervasyon;
                ceza = res.data.ceza;
                yolGecisUcreti = res.data.yolGecisUcreti;
                sigorta = res.data.sigorta;
                doktorlukucreti = res.data.doktorlukUcreti;
                ardiye = res.data.ardiye;
                guncelborc = res.data.guncelBorc;
                if(gidecegiUlke==1)
                {
                    gidecegiUlkeStr= "Trieste";
                }
                else if(gidecegiUlke==2)
                {
                    gidecegiUlkeStr= "Bari";
                }
                else if(gidecegiUlke==3)
                {
                    gidecegiUlkeStr= "Sete";
                }
                if(this.props.tur == 1 || this.props.tur == 4)
                {
                    turStr = "İHRACAT";
                }
                else
                {
                    turStr = "İTHALAT";
                }
                popupWin.document.write(`
    <html>
<!-- Google Font: Source Sans Pro -->
<style>
body{
font-size: 12px;
}
    .logo{
        margin-top: 40px;
        position: absolute;
        width: 150px;
        margin-left: -50px;
    }

    .years20{
        margin-top: 30px;
        position: absolute;
        margin-left: 550px;
    }
    .title{
        margin-top: 97px;
        position: absolute;
        margin-left: 357px;
    }
    .years20 img{
        width: 150px;
    }
    .firma{
    position: absolute;
        margin-top: 24px;
    }
    .plaka{
    position: absolute;
        margin-top: 48px;
    }
    .hat{
    position: absolute;
        margin-top: 72px;
    }
    .tur{
    position: absolute;
        margin-top: 216px;
        margin-left: 390px;
    }
    .toplam{
    position: absolute;
        margin-top: 0px;
        margin-left: 390px;
    }
    .tutar{
    position: absolute;
        margin-top: 24px;
        margin-left: 390px;
    }
    .rezervazyon{
    position: absolute;
        margin-top: 48px;
        margin-left: 390px;
    }
    .ceza{
    position: absolute;
        margin-top: 72px;
        margin-left: 390px;
    }
    .yolgecisucreti{
    position: absolute;
        margin-top: 96px;
        margin-left: 390px;
    }
    .sigorta{
    position: absolute;
        margin-top: 120px;
        margin-left: 390px;
    }
    .doktorlukucreti{
    position: absolute;
        margin-top: 144px;
        margin-left: 390px;
    }
    .ardiye{
    position: absolute;
        margin-top: 168px;
        margin-left: 390px;
    }
    .guncelborc{
    position: absolute;
        margin-top: 192px;
        margin-left: 390px;
    }
    .aciklama{
    position: absolute;
        margin-top: 240px;
    }
    .enalt{
    position: absolute;
        margin-top: 264px;
    }
    .left
    {
        float: left;
    }
    .border
    {
        border: solid 1px #000;
        padding: 2px;
    }
    .width80{
        width: 80px;
    }
    .width50{
        width: 50px;
    }
    .width100{
        width: 100px;
    }
    .width140{
        width: 140px;
    }
    .width150{
        width: 150px;
    }
    .width200{
        width: 200px;
    }
    .width580{
        width: 580px;
            min-height: 15px;   
    }
    .width340{
        width: 340px;
        font-size: 10px;
    }
</style>
<head>
    <title>Print</title>
</head>
<body onload="window.print()" >
<div>
    <div class="content left">
        <div>
        <div><div class="left tarih border width80">TARİH</div><div class="tarihsag left border width200">`+tarih+`</div></div>
            <div class="firma left"><div class="left tarih border width80">FİRMA</div><div class="tarihsag left border width200">`+firma+`</div></div>
            <div class="left plaka"> <div class="left tarih border width80">PLAKA</div><div class="tarihsag left border width200">`+plaka+` €</div></div>
            <div class="left toplam"> <div class="left tarih border width140">TOPLAM</div><div class="tarihsag left border width150">`+(forklift+rezervasyon+ceza+yolGecisUcreti+sigorta)+` €</div></div>
            <div class="left tutar"> <div class="left tarih border width140">FORKLİFT</div><div class="tarihsag left border width150">`+forklift+` €</div></div>
            <div class="left rezervazyon"> <div class="left tarih border width140">REZERVASYON</div><div class="tarihsag left border width150">`+rezervasyon+` €</div></div>
            <div class="left ceza"> <div class="left tarih border width140">CEZA</div><div class="tarihsag left border width150">`+ceza+` €</div></div>
            <div class="left yolgecisucreti"> <div class="left tarih border width140">YOL GEÇİŞ ÜCRETİ</div><div class="tarihsag left border width150">`+yolGecisUcreti+` €</div></div>
            <div class="left sigorta"> <div class="left tarih border width140">SİGORTA</div><div class="tarihsag left border width150">`+sigorta+` €</div></div>
            <div class="left guncelborc"> <div class="left tarih border width140">GÜNCEL BORÇ</div><div class="tarihsag left border width150">`+guncelborc+` €</div></div>
            <div class="left ardiye"> <div class="left tarih border width140">ARDİYE</div><div class="tarihsag left border width150">`+ardiye+` €</div></div>
            <div class="left doktorlukucreti"> <div class="left tarih border width140">DOKTORLUK ÜCRETİ</div><div class="tarihsag left border width150">`+doktorlukucreti+` €</div></div>
            <div class="left hat"> <div class="left tarih border width80">Hat:</div><div class="tarihsag left border width200">`+gidecegiUlkeStr+`</div></div>
            <div class="left tur"> <div class="left tarih border width140">`+turStr+`</div><div class="tarihsag left border width150">X</div></div>
            <div class="left aciklama"> <div class="left tarih border width100">AÇIKLAMA</div><div class="tarihsag left border width580">`+this.state.aciklama+`</div></div>
            <div class="left enalt"> <div class="left tarih border width340">Aydıntepe Mah. 100.Yıl cad. No:12/33 P:Code: 34947 Tuzla/İstanbul</div><div class="tarihsag left border width340">ucarsoy@gmail.com | www.ucarsoy.com</div></div>
    </div>
        <div>
</div>
</div>
</div>
</body>

</html>
  
    `);
                popupWin.document.close();
            }).catch(res => {
        });

        /*window.history.back();*/
        /*window.disableModal();*/
        /*axios({
            method: 'post',
            url: Properties.baseUrl + '/tasima/changeDurum',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem("token")
            },
            data: {
                id: this.state.makbuzId,
                durum: this.state.makbuzDurum,
            }
        })
            .then(res => {
                window.successful((this.state.showDuzenle ? "Makbuz Güncellendi." : "Makbuz Kaydedildi"));
            }).catch(res => {
            window.unsuccessful((this.state.showDuzenle ? "Makbuz Güncellenemedi." : "Makbuz Kaydedilemedi."));
        });*/
    }


    onChange = e => {
        this.setState({ [e.target.name]: e.target.value });

        if(e.target.name === "sigorta")
        {
            this.setState({ "sigortaSecim": e.target.options[e.target.selectedIndex].text });
        }
        if(e.target.name === "yolGecisUcreti")
        {
            this.setState({ "yolGecisUcretiSecim": e.target.options[e.target.selectedIndex].text });
        }
if(e.target.name === "genel")
{
    if(e.target.value == 1)
    {
        this.setState({ "hepsiUcak":0 });
        this.setState({ "hepsiGemi":1 });
        this.setState({ "gemiUcreti":1 });
        this.setState({ "ets":1 });
        this.setState({ "baf":1 });
        this.setState({ "ens":1 });
        this.setState({ "liman":1 });
        this.setState({ "xray":1 });
        this.setState({ "soforUcreti": 1 });
    }
    else if(e.target.value == 2)
    {
        this.setState({ "hepsiUcak":1 });
        this.setState({ "hepsiGemi":0 });
        this.setState({ "gemiUcreti":1 });
        this.setState({ "ets":1 });
        this.setState({ "baf":1 });
        this.setState({ "ens":1 });
        this.setState({ "liman":1 });
        this.setState({ "xray":1 });
        this.setState({ "soforUcreti": 2 });
    }
    else if(e.target.value == 3)
    {
        this.setState({ "hepsiUcak":0 });
        this.setState({ "hepsiGemi":0 });
        this.setState({ "gemiUcreti":1 });
        this.setState({ "ets":1 });
        this.setState({ "baf":1 });
        this.setState({ "ens":1 });
        this.setState({ "liman":1 });
        this.setState({ "xray":1 });
        this.setState({ "soforUcreti": 0 });
    }
    else{
        this.setState({ "hepsiUcak":0 });
        this.setState({ "hepsiGemi":0 });
        this.setState({ "gemiUcreti":0 });
        this.setState({ "ets":0 });
        this.setState({ "baf":0 });
        this.setState({ "ens":0 });
        this.setState({ "liman":0 });
        this.setState({ "xray":0 });
        this.setState({ "soforUcreti":0 });
    }
}

        this.hesapla();
    }
    cikis = e => {
        window.disableModal();
        window.location.reload();
    }
    onChangeCheck = e => {
        console.log([e.target.name]);
        if (e.target.checked) {
            this.setState({ [e.target.name]: 1 });
        }
        else
        {
            this.setState({ [e.target.name]: 0 });
        }
        this.hesapla();
    }
    get = e => {
        let status = true;
        if(localStorage.getItem("tasimaId")==null)
        {
            status = false;
        }
        if (status) {
            axios({
                method: 'get',
                url: Properties.baseUrl + '/ucretbelirle/get/'+this.state.tasimaId,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + localStorage.getItem("token")
                }
            })
                .then(res => {
                    this.setState({ gemiUcreti: res.data.gemiUcreti });
                    this.setState({ gemiUcretiOdeme: res.data.gemiUcretiOdeme });
                    this.setState({ baf: res.data.baf });
                    this.setState({ ens: res.data.ens });
                    this.setState({ bafOdeme: res.data.bafOdeme });
                    this.setState({ ets: res.data.ets });
                    this.setState({ etsOdeme: res.data.etsOdeme });
                    this.setState({ liman: res.data.liman });
                    this.setState({ limanOdeme: res.data.limanOdeme });
                    this.setState({ soforUcreti: res.data.soforUcreti });
                    if(res.data.soforUcreti == "1")
                    {

                        this.setState({ hepsiGemi: "1" });
                    }
                    else if(res.data.soforUcreti == "2")
                    {

                        this.setState({ hepsiUcak: "1" });
                    }
                    this.setState({ soforUcreti: res.data.soforUcreti });
                    this.setState({ soforUcretiOdeme: res.data.soforUcretiOdeme });
                    this.setState({ ekSofor: res.data.ekSofor });
                    this.setState({ ekSoforOdeme: res.data.ekSoforOdeme });
                    this.setState({ xray: res.data.xray });
                    this.setState({ xrayOdeme: res.data.xrayOdeme });
                    this.setState({ yanici: res.data.yanici });
                    this.setState({ yaniciOdeme: res.data.yaniciOdeme });
                    this.setState({ rezervasyon: res.data.rezervasyon });
                    this.setState({ rezervasyonOdeme: res.data.rezervasyonOdeme });
                    this.setState({ forklift: res.data.forklift });
                    this.setState({ forkliftOdeme: res.data.forkliftOdeme });
                    this.setState({ ceza: res.data.ceza });
                    this.setState({ cezaOdeme: res.data.cezaOdeme });
                    this.setState({ hizmetBedeli: res.data.hizmetBedeli });
                    this.setState({ ardiye: res.data.ardiye });
                    this.setState({ guncelBorc: res.data.guncelBorc });
                    this.setState({ ardiyeOdeme: res.data.ardiyeOdeme });
                    this.setState({ doktorluk: res.data.doktorluk });
                    this.setState({ doktorlukOdeme: res.data.doktorlukOdeme });
                    this.setState({ yolGecisUcreti: res.data.yolGecisUcreti });
                    this.setState({ yolGecisUcretiOdeme: res.data.yolGecisUcretiOdeme });
                    this.setState({ sigorta: res.data.sigorta });
                    this.setState({ sigortaOdeme: res.data.sigortaOdeme });
                    this.setState({ yolGecisUcretiSecim: res.data.yolGecisUcretiSecim });
                    this.setState({ sigortaSecim: res.data.sigortaSecim });
                    this.setState({ gidecegiUlke: res.data.gidecegiUlke });
                    this.setState({ genel: res.data.genel });
                    this.hesapla(res.data.gidecegiUlke);

                }).catch(res => {
                    window.unsuccessful((this.state.showDuzenle ? "Ek Bilgi Güncellenemedi." : "Ek Bilgi Kaydedilemedi."));
                });
        }
    }
    hesapla = e => {
        let gidecegiUlke = 0
        if(e != undefined)
        {
            gidecegiUlke = e;
        }
        else{
            gidecegiUlke = this.state.gidecegiUlke;
        }
        axios({
            method: 'get',
            url: Properties.baseUrl + '/tarife/get/'+gidecegiUlke,
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        })
            .then(res => {
                let localToplam = 0;
                if (this.state.gemiUcreti) {
                    localToplam = localToplam +  Number(res.data.gemiUcretiTarife.toFixed(1));
                    this.setState({ gemiUcretiOdeme: res.data.gemiUcretiTarife });
                }
                else {
                    this.setState({ gemiUcretiOdeme: 0 });
                }
                if (this.state.baf)
                {
                    localToplam = localToplam +  Number(res.data.bafTarife.toFixed(1));
                    this.setState({ bafOdeme: res.data.bafTarife });
                }
                else{
                    this.setState({ bafOdeme: 0 });
                }
                if (this.state.ens)
                {
                    localToplam = localToplam +  Number(res.data.ens.toFixed(1));
                    this.setState({ ensOdeme: res.data.ens });
                }
                else{
                    this.setState({ ensOdeme: 0 });
                }
                if (this.state.ets)
                {
                    localToplam = localToplam +  Number(res.data.etsTarife.toFixed(1));
                    this.setState({ etsOdeme: res.data.etsTarife });
                }
                else{
                    this.setState({ etsOdeme: 0 });
                }
                if (this.state.liman)
                {
                    localToplam = localToplam +  Number(res.data.limanTarife.toFixed(1));
                    this.setState({ limanOdeme: res.data.limanTarife });
                }
                else{
                    this.setState({ limanOdeme: 0 });
                }
                if (this.state.xray)
                {
                    localToplam = localToplam +  Number(res.data.xrayTarife.toFixed(1));
                    this.setState({ xrayOdeme: res.data.xrayTarife });
                }
                else{
                    this.setState({ xrayOdeme: 0 });
                }
                if (this.state.yanici)
                {
                    localToplam = localToplam +  Number(res.data.yaniciTarife.toFixed(1));
                    this.setState({ yaniciOdeme: res.data.yaniciTarife });
                }
                else{
                    this.setState({ yaniciOdeme: 0 });
                }
                if (this.state.rezervasyon)
                {
                    localToplam = localToplam + Number(res.data.rezervasyonTarife.toFixed(1));
                    this.setState({ rezervasyonOdeme: res.data.rezervasyonTarife });
                }
                else{
                    this.setState({ rezervasyonOdeme: 0 });
                }
                if (this.state.soforUcreti == 1) {
                    localToplam = localToplam + Number(res.data.soforUcretiTarifeGemi.toFixed(1));
                    this.setState({ soforUcretiOdeme: res.data.soforUcretiTarifeGemi });
                }
                else if (this.state.soforUcreti == 2)
                {
                    localToplam = localToplam + Number(res.data.soforUcretiTarifeUcak.toFixed(1));
                    this.setState({ soforUcretiOdeme: res.data.soforUcretiTarifeUcak });
                }
                else{
                    this.setState({ soforUcretiOdeme: 0 });
                }
                if (this.state.ekSofor == 1)
                {
                    localToplam = localToplam + Number(res.data.ekSoforTarifeGemi.toFixed(1));
                    this.setState({ ekSoforOdeme: res.data.ekSoforTarifeGemi });
                }
                else if (this.state.ekSofor == 2)
                {
                    localToplam = localToplam + Number(res.data.ekSoforTarifeUcak.toFixed(1));
                    this.setState({ ekSoforOdeme: res.data.ekSoforTarifeUcak });
                } else{
                    this.setState({ ekSoforOdeme: 0 });
                }

                localToplam = Number(parseFloat(Number(localToplam)+Number(this.state.forklift)).toFixed(1));
                this.setState({ forkliftOdeme: Number(parseFloat(this.state.forklift).toFixed(1)) });
                localToplam = Number(parseFloat(Number(localToplam)+Number(this.state.ceza)).toFixed(1));
                this.setState({ cezaOdeme: parseFloat(this.state.ceza).toFixed(1) });
                localToplam = Number(parseFloat(Number(localToplam)+Number(this.state.doktorluk)).toFixed(1));
                this.setState({ doktorlukOdeme: parseFloat(this.state.doktorluk).toFixed(1) });
                localToplam = Number(parseFloat(Number(localToplam)+Number(this.state.ardiye)).toFixed(1));
                this.setState({ ardiyeOdeme: parseFloat(this.state.ardiye).toFixed(1) });
                localToplam =Number(parseFloat(Number(localToplam)+Number(this.state.hizmetBedeli)).toFixed(1));
                this.setState({ hizmetBedeliOdeme: Number(parseFloat(res.data.hizmetBedeli).toFixed(1)) });
                this.setState({ hizmetBedeli:Number( parseFloat(res.data.hizmetBedeli).toFixed(1)) });
                localToplam = Number(parseFloat(Number(localToplam)+Number(this.state.guncelBorc)).toFixed(1));
                this.setState({ guncelBorcOdeme: Number(parseFloat(this.state.guncelBorc).toFixed(1)) });
                localToplam = Number(parseFloat(Number(localToplam)+Number(this.state.yolGecisUcreti)).toFixed(1));
                this.setState({ yolGecisUcretiOdeme: Number(parseFloat(this.state.yolGecisUcreti).toFixed(1)) });
                localToplam =Number(parseFloat(Number(localToplam)+Number(this.state.sigorta)).toFixed(1));
                this.setState({ sigortaOdeme: Number(parseFloat(this.state.sigorta).toFixed(1))});
                this.setState({ toplam: localToplam });
            }).catch(res => {
                console.log(res);
                window.unsuccessful((this.state.showDuzenle ? "Ücret Belirle  Güncellenemedi." : "Ücret Belirle  Kaydedilemedi."));
            });
    }
    ucretBelirleSave = e => {
        let status = true;
        if (status) {
            axios({
                method: 'post',
                url: Properties.baseUrl + '/ucretbelirle/save',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + localStorage.getItem("token")
                },
                data: {
                    tasimaId: this.state.tasimaId,
                    gemiUcreti: this.state.gemiUcreti,
                    gemiUcretiOdeme: this.state.gemiUcretiOdeme,
                    baf: this.state.baf,
                    ens: this.state.ens,
                    ensOdeme: this.state.ensOdeme,
                    bafOdeme: this.state.bafOdeme,
                    ets: this.state.ets,
                    etsOdeme: this.state.etsOdeme,
                    liman: this.state.liman,
                    limanOdeme: this.state.limanOdeme,
                    soforUcreti: this.state.soforUcreti,
                    soforUcretiOdeme: this.state.soforUcretiOdeme,
                    ekSofor: this.state.ekSofor,
                    ekSoforOdeme: this.state.ekSoforOdeme,
                    xray: this.state.xray,
                    xrayOdeme: this.state.xrayOdeme,
                    yanici: this.state.yanici,
                    yaniciOdeme: this.state.yaniciOdeme,
                    rezervasyon: this.state.rezervasyon,
                    rezervasyonOdeme: this.state.rezervasyonOdeme,
                    forklift: this.state.forklift,
                    forkliftOdeme: this.state.forkliftOdeme,
                    ceza: this.state.ceza,
                    cezaOdeme: this.state.cezaOdeme,
                    doktorluk: this.state.doktorluk,
                    doktorlukOdeme: this.state.doktorlukOdeme,
                    guncelBorc: this.state.guncelBorc,
                    ardiye: this.state.ardiye,
                    hizmetBedeli: this.state.hizmetBedeli,
                    ardiyeOdeme: this.state.ardiyeOdeme,
                    yolGecisUcreti: this.state.yolGecisUcreti,
                    yolGecisUcretiOdeme: this.state.yolGecisUcretiOdeme,
                    sigorta: this.state.sigorta,
                    sigortaOdeme: this.state.sigortaOdeme,
                    yolGecisUcretiSecim: this.state.yolGecisUcretiSecim,
                    sigortaSecim: this.state.sigortaSecim,
                    genel: this.state.genel
                }
            })
                .then(res => {
                    window.successful((this.state.showDuzenle ? "Ücret Belirle Güncellendi." : "Ücret Belirle  Kaydedildi"));
                    window.location.reload();
                }).catch(res => {
                    window.unsuccessful((this.state.showDuzenle ? "Ücret Belirle  Güncellenemedi." : "Ücret Belirle  Kaydedilemedi."));
                });
        }
    }
    render() {
        const button = {
            marginTop: "0px",
            marginLeft: "10px",
            float: "left",
            width: "100px"
        };
        return (
            <div>
                    <form>
                        <div className="card card-primary">
                            <div className="card-body">
                                <div className="row">
                                    <div style={{"display": "None"}}>
                                        <div className="col-2" style={{"display": "None"}}>
                                            <label htmlFor="exampleInputPassword1">GEMİ ÜCRETİ</label>
                                            <div className="form-check">
                                                <input type="checkbox" className="form-check-input" name="gemiUcreti"
                                                       checked={this.state.gemiUcreti} onChange={this.onChangeCheck}
                                                       value={0}/>
                                                <label className="form-check-label" htmlFor="exampleCheck1"></label>
                                            </div>
                                        </div>
                                        <div className="col-2">
                                            <label htmlFor="exampleInputPassword1">BAF</label>
                                            <div className="form-check">
                                                <input type="checkbox" className="form-check-input" id="aCevap"
                                                       checked={this.state.baf} onChange={this.onChangeCheck}
                                                       name="baf" value={0}/>
                                                <label className="form-check-label" htmlFor="exampleCheck1"></label>
                                            </div>
                                        </div>
                                        <div className="col-2" style={{"display": "None"}}>
                                            <label htmlFor="exampleInputPassword1">ETS</label>
                                            <div className="form-check">
                                                <input type="checkbox" className="form-check-input" id="ets"
                                                       checked={this.state.ets} onChange={this.onChangeCheck}
                                                       name="ets" value={0}/>
                                                <label className="form-check-label" htmlFor="exampleCheck1"></label>
                                            </div>
                                        </div>
                                        <div className="col-2" style={{"display": "None"}}>
                                            <label htmlFor="exampleInputPassword1">LİMAN</label>
                                            <div className="form-check">
                                                <input type="checkbox" className="form-check-input" id="liman"
                                                       checked={this.state.liman} onChange={this.onChangeCheck}
                                                       name="liman" value={0}/>
                                                <label className="form-check-label" htmlFor="exampleCheck1"></label>
                                            </div>
                                        </div>
                                        <div className="col-2" style={{"display": "None"}}>
                                            <label htmlFor="exampleInputPassword1">ŞOFÖR ÜCRETİ</label>
                                            <div className="form-check">
                                                <select value={this.state.soforUcreti} name="soforUcreti"
                                                        className="form-control select2" onChange={this.onChange}>
                                                    <option value={0} selected="selected">SEÇ</option>
                                                    <option value={1}>GEMİ</option>
                                                    <option value={2}>UÇAK</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div className="col-2">
                                            <label htmlFor="exampleInputPassword1">XRAY</label>
                                            <div className="form-check">
                                                <input type="checkbox" className="form-check-input" id="xray"
                                                       checked={this.state.xray} onChange={this.onChangeCheck}
                                                       name="xray" value={0}/>
                                                <label className="form-check-label" htmlFor="exampleCheck1"></label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-5">
                                        <div className="col-12" style={{"text-align": "center","display": "None"}}>
                                            <label htmlFor="exampleInputPassword1">GEMİ ÜCRETİ KABİN</label>
                                            <div className="form-check">
                                                <input type="checkbox" className="form-check-input" name="hepsiGemi"
                                                       checked={this.state.hepsiGemi} onChange={this.onChangeCheck}
                                                       value={0}/>
                                                <label className="form-check-label" htmlFor="exampleCheck1"></label>
                                            </div>
                                        </div>
                                        <div className="col-12" style={{"text-align": "center","display": "None"}}>
                                            <label htmlFor="exampleInputPassword1">GEMİ ÜCRETİ UÇAK</label>
                                            <div className="form-check">
                                                <input type="checkbox" className="form-check-input" name="hepsiUcak"
                                                       checked={this.state.hepsiUcak} onChange={this.onChangeCheck}
                                                       value={0}/>
                                                <label className="form-check-label" htmlFor="exampleCheck1"></label>
                                            </div>
                                        </div>
                                        <div className="col-12" style={{"text-align": "center"}}>
                                            <label htmlFor="exampleInputPassword1">GENEL</label>
                                            <div className="form-check">
                                                <select value={this.state.genel} name="genel"
                                                        className="form-control select2" onChange={this.onChange}>
                                                    <option value={0} selected="selected">SEÇ</option>
                                                    <option value={1}>KABİN</option>
                                                    <option value={2}>UÇAK</option>
                                                    <option value={3}>SÜRÜCÜSÜZ</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-12" style={{"text-align": "center"}}>
                                            <label htmlFor="exampleInputPassword1">EK SÜRÜCÜ</label>
                                            <div className="form-check">
                                                <select value={this.state.ekSofor} name="ekSofor"
                                                        className="form-control select2" onChange={this.onChange}>
                                                    <option value={0} selected="selected">SEÇ</option>
                                                    <option value={1}>GEMİ</option>
                                                    <option value={2}>UÇAK</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-12" style={{"text-align": "center"}}>
                                            <label htmlFor="exampleInputPassword1">YANICI</label>
                                            <div className="form-check">
                                                <input type="checkbox" className="form-check-input" id="yanici"
                                                       checked={this.state.yanici} onChange={this.onChangeCheck}
                                                       name="yanici" value={0}/>
                                                <label className="form-check-label" htmlFor="exampleCheck1"></label>
                                            </div>
                                        </div>
                                        <div className="col-12" style={{"text-align": "center"}}>
                                            <label htmlFor="exampleInputPassword1">HİZMET BEDELİ</label>
                                            <div className="form-check">
                                                <label className="form-check-label"
                                                       htmlFor="exampleCheck1">{this.state.hizmetBedeli} €</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-2">
                                    </div>
                                    <div className="col-5">
                                        <div className="col-12" style={{"text-align": "center"}}>
                                            <label htmlFor="exampleInputPassword1">FOKLİFT</label>
                                            <div className="form-check">
                                                <input value={this.state.forklift} type="number"
                                                       className="form-control"
                                                       name="forklift" onChange={this.onChange}
                                                       placeholder="Foklift Ücreti €"/>
                                            </div>
                                        </div>
                                        <div className="col-12" style={{"text-align": "center"}}>
                                            <label htmlFor="exampleInputPassword1">REZERVASYON</label>
                                            <div className="form-check">
                                                <input type="checkbox" className="form-check-input" id="rezervasyon"
                                                       checked={this.state.rezervasyon} onChange={this.onChangeCheck}
                                                       name="rezervasyon" value={0}/>
                                                <label className="form-check-label" htmlFor="exampleCheck1"></label>
                                            </div>
                                        </div>
                                        <div className="col-12" style={{"text-align": "center"}}>
                                            <label htmlFor="exampleInputPassword1">CEZA</label>
                                            <div className="form-check">
                                                <input value={this.state.ceza} type="number" className="form-control"
                                                       name="ceza" onChange={this.onChange}
                                                       placeholder="Ceza Ücreti €"/>
                                            </div>
                                        </div>
                                        <div className="col-12" style={{"text-align": "center"}}>
                                            <label htmlFor="exampleInputPassword1">ARDİYE</label>
                                            <div className="form-check">
                                                <input value={this.state.ardiye} type="number" className="form-control"
                                                       name="ardiye" onChange={this.onChange}
                                                       placeholder="Ardiye Ücreti €"/>
                                            </div>
                                        </div>
                                        <div className="col-12" style={{"text-align": "center"}}>
                                            <label htmlFor="exampleInputPassword1">GÜNCEL BORÇ</label>
                                            <div className="form-check">
                                                <input value={this.state.guncelBorc} type="number" className="form-control"
                                                       name="guncelBorc" onChange={this.onChange}
                                                       placeholder="Güncel Borç Ücreti €"/>
                                            </div>
                                        </div>
                                        <div className="col-12" style={{"text-align": "center"}}>
                                            <label htmlFor="exampleInputPassword1">DOKTORLUK ÜCRETİ</label>
                                            <div className="form-check">
                                                <input value={this.state.doktorluk} type="number" className="form-control"
                                                       name="doktorluk" onChange={this.onChange}
                                                       placeholder="Doktorluk Ücreti €"/>
                                            </div>
                                        </div>
                                        <div className="col-12" style={{"text-align": "center"}}>
                                            <label htmlFor="exampleInputPassword1">YOL GEÇİŞ ÜCRETİ</label>
                                            <div className="form-check">
                                                <select onChange={this.onChange} name="yolGecisUcreti"
                                                        className="form-control select2"
                                                        value={this.state.yolGecisUcreti}>
                                                    <option value={0} selected="selected">Yol Geçiş Seç</option>
                                                    <option value={this.state.gurbulak} selected="selected">GÜRBULAK
                                                    </option>
                                                    <option value={this.state.esendere} selected="selected">ESENDERE
                                                    </option>
                                                    <option value={this.state.dilucu} selected="selected">DİLUCU
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-12" style={{"text-align": "center"}}>
                                            <label htmlFor="exampleInputPassword1">SİGORTA</label>
                                            <div className="form-check">
                                                <select onChange={this.onChange} name="sigorta"
                                                        className="form-control select2" value={this.state.sigorta}>
                                                    <option value={0} selected="selected">Sigorta Seç</option>
                                                    <option value={this.state.sigorta1ay} selected="selected">1 Ay
                                                    </option>
                                                    <option value={this.state.sigorta2ay} selected="selected">2 Ay
                                                    </option>
                                                    <option value={this.state.sigorta3ay} selected="selected">3 Ay
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <label htmlFor="exampleInputPassword1">TOPLAM: {this.state.toplam} €</label>
                                    </div>
                                        <div className="col-5">
                                            <input type="text" value={this.state.aciklama} className="form-control"
                                                   name="aciklama" onChange={this.onChange}
                                                   placeholder="Açıklama"/>
                                            <button type="button"
                                                    className="btn btn-block btn-outline-primary"
                                                    onClick={e => this.makbuzYazdir()}
                                            >ÜCRET BELİRLE MAKBUZ<i className="fas fa-print"></i>
                                            </button>
                                        </div>
                                        <div className="col-2"></div>
                                        <div className="col-5">
                                            <input type="text" value={this.state.aciklama2} className="form-control"
                                                   name="aciklama" onChange={this.onChange}
                                                   placeholder="Açıklama"/>
                                            <button type="button"
                                                    className="btn btn-block btn-outline-primary"
                                                    onClick={e => this.ekOdemeMakbuzYazdir()}
                                            >EK ÖDEME MAKBUZ<i className="fas fa-print"></i>
                                            </button>
                                        </div>
                                </div>

                            </div>
                            <div className="card-footer row">
                                <div className="col-1">
                                    <button type="button" onClick={this.ucretBelirleSave}
                                            className="btn btn-block btn-primary">Kaydet
                                    </button>
                                </div>
                                <div className="col-1">
                                    <button type="button" onClick={e => this.cikis()}
                                            className="btn btn-block btn-outline-info">ÇIKIŞ
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>

            </div>);
    }
}


export default withRouter(UcretBelirlePopup);
